const moment = require('moment');

class StashMetadataService {
    /**
     * @param {CurrentDevice} currentDevice
     * @param {UserService} userService
     */
    constructor(
        currentDevice,
        userService,
    ) {
        this.currentDevice = currentDevice;
        this.userService = userService;
    }

    /**
     * @param {StashedCart} stashedCart
     */
    getUsername(stashedCart) {
        let username = stashedCart.username;

        if (this.userService.getUsername() && username === this.userService.getUsername()) {
            username = 'You (' + username + ')';
        }

        return username;
    }

    /**
     * @param {StashedCart} stashedCart
     *
     * @return {string}
     */
    getRelativeTime(stashedCart) {
        if (stashedCart.stashedAt) {
            return moment(stashedCart.stashedAt).fromNow();
        }

        return '';
    }

    /**
     * @param {StashedCart} stashedCart
     *
     * @return {string}
     */
    getDeviceLabel(stashedCart) {
        let deviceID = stashedCart.deviceID;

        if (deviceID) {
            if (deviceID === this.currentDevice.getDeviceId()) {
                return 'This Device';
            }
            return 'Another Device';
        }

        return '';
    }
}

module.exports = StashMetadataService;
